var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/BudgetSummaryEnums';
import moment from 'moment';
let BudgetSummaryModule = class BudgetSummaryModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.budgetSummaryList = [];
        this.budgetSummaryId = [];
        this.budgetSummaryDesc = [];
        this.budgetSummaryVersion = [];
        this.budgetSummaryDateFrom = [];
        this.budgetSummaryDateTo = [];
        this.budgetSummaryType = [];
        this.selectedCategoryId = [];
        this.selectedCategoryDesc = [];
        this.selectedCategoryVersion = [];
        this.selectedCategoryDateFrom = '';
        this.selectedCategoryDateTo = '';
        this.useFilter = true;
        this.budgetSummaryPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.desc = '';
        this.status = '';
        this.statusMessage = '';
        this.lastVersion = 0;
        // validate: ==============================================
        this.dataValidate = [];
        this.pageValidate = 1;
        this.sizeValidate = 10;
        this.descValidate = '';
        this.budgetSummaryPagingValidate = [];
        this.loadPageValidate = false;
        // detail: ==============================================
        this.dataDetail = [];
        this.pageDetail = 1;
        this.sizeDetail = 10;
        this.descDetail = '';
        this.budgetSummaryPagingDetail = [];
        this.loadPageDetail = false;
    }
    get getBudgetSummaryLoading() {
        return this.loading;
    }
    get getBudgetSummaryDataList() {
        return this.budgetSummaryList;
    }
    get getBudgetSummaryListId() {
        return this.budgetSummaryId;
    }
    get getBudgetSummaryListDesc() {
        return this.budgetSummaryDesc;
    }
    get getBudgetSummaryListVersion() {
        return this.budgetSummaryVersion;
    }
    get getBudgetSummaryListDateFrom() {
        return this.budgetSummaryDateFrom;
    }
    get getBudgetSummaryListDateTo() {
        return this.budgetSummaryDateTo;
    }
    get getBudgetSummarySelectedId() {
        return this.selectedCategoryId;
    }
    get getBudgetSummarySelectedDesc() {
        return this.selectedCategoryDesc;
    }
    get getBudgetSummarySelectedVersion() {
        return this.selectedCategoryVersion;
    }
    get getBudgetSummaryDateFrom() {
        return this.selectedCategoryDateFrom;
    }
    get getBudgetSummaryDateTo() {
        return this.selectedCategoryDateTo;
    }
    get getBudgetSummaryPaging() {
        return this.budgetSummaryPaging;
    }
    get getBudgetSummarySize() {
        return this.size;
    }
    get getBudgetSummaryStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getBudgetSummaryUseFilter() {
        return this.useFilter;
    }
    get getDataBudgetSummaryType() {
        return this.budgetSummaryType;
    }
    get getDataBudgetSummaryVersion() {
        return this.lastVersion;
    }
    // validate: ==============================================
    get getBudgetSummaryValidateData() {
        return this.dataValidate;
    }
    get getBudgetSummaryPagingValidate() {
        return this.budgetSummaryPagingValidate;
    }
    // detail: ==============================================
    get getBudgetSummaryDetailData() {
        return this.dataDetail;
    }
    get getBudgetSummaryPagingDetail() {
        return this.budgetSummaryPagingDetail;
    }
    [_a = Mutations.SET_BUDGET_SUMMARY_LOADING](payload) {
        this.loading = payload;
    }
    [_b = Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_c = Mutations.SET_BUDGET_SUMMARY_LIST](payload) {
        this.budgetSummaryList = payload;
    }
    [_d = Mutations.SET_BUDGET_SUMMARY_LIST_ID](payload) {
        this.budgetSummaryId = payload;
    }
    [_e = Mutations.SET_BUDGET_SUMMARY_LIST_DESC](payload) {
        this.budgetSummaryDesc = payload;
    }
    [_f = Mutations.SET_BUDGET_SUMMARY_LIST_VERSION](payload) {
        this.budgetSummaryVersion = payload;
    }
    [_g = Mutations.SET_BUDGET_SUMMARY_LIST_DATE_FROM](payload) {
        this.budgetSummaryDateFrom = payload;
    }
    [_h = Mutations.SET_BUDGET_SUMMARY_LIST_DATE_TO](payload) {
        this.budgetSummaryDateTo = payload;
    }
    [_j = Mutations.SET_SELECTED_BUDGET_SUMMARY_ID](payload) {
        this.selectedCategoryId = payload;
    }
    [_k = Mutations.SET_SELECTED_BUDGET_SUMMARY_DESC](payload) {
        this.selectedCategoryDesc = payload;
    }
    [_l = Mutations.SET_SELECTED_BUDGET_SUMMARY_VERSION](payload) {
        this.selectedCategoryVersion = payload;
    }
    [_m = Mutations.SET_SELECTED_BUDGET_SUMMARY_DATE_FROM](payload) {
        this.selectedCategoryDateFrom = payload;
    }
    [_o = Mutations.SET_SELECTED_BUDGET_SUMMARY_DATE_TO](payload) {
        this.selectedCategoryDateTo = payload;
    }
    [_p = Mutations.SET_BUDGET_SUMMARY_PAGE](payload) {
        this.budgetSummaryPaging = payload;
    }
    [_q = Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_r = Mutations.SET_BUDGET_SUMMARY_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_s = Mutations.SET_BUDGET_SUMMARY_SIZE](payload) {
        this.size = payload;
    }
    [_t = Mutations.SET_BUDGET_SUMMARY_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_u = Mutations.SET_BUDGET_SUMMARY_TYPE](payload) {
        this.budgetSummaryType = payload;
    }
    [_v = Mutations.SET_BUDGET_SUMMARY_VERSION](payload) {
        this.lastVersion = payload;
    }
    // validate: ==============================================
    [_w = Mutations.SET_BUDGET_SUMMARY_VALIDATE](payload) {
        this.dataValidate = payload;
    }
    [_x = Mutations.SET_BUDGET_SUMMARY_PAGE_VALIDATE](payload) {
        this.budgetSummaryPagingValidate = payload;
    }
    [_y = Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE_VALIDATE]() {
        this.loadPageValidate = true;
    }
    [_z = Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE_VALIDATE](payload) {
        this.pageValidate = payload;
    }
    [_0 = Mutations.SET_BUDGET_SUMMARY_HANDLE_SIZE_VALIDATE](payload) {
        this.sizeValidate = payload;
    }
    // detail: ==============================================
    [_1 = Mutations.SET_BUDGET_SUMMARY_DETAIL](payload) {
        this.dataDetail = payload;
    }
    [_2 = Mutations.SET_BUDGET_SUMMARY_PAGE_DETAIL](payload) {
        this.budgetSummaryPagingDetail = payload;
    }
    [_3 = Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE_DETAIL]() {
        this.loadPageDetail = true;
    }
    [_4 = Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE_DETAIL](payload) {
        this.pageDetail = payload;
    }
    [_5 = Mutations.SET_BUDGET_SUMMARY_DETAIL_SIZE](payload) {
        this.sizeDetail = payload;
    }
    [_6 = Actions.GET_BUDGET_SUMMARY_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budget/upload/budgetheader`;
            const params = {
                ver: 'v1',
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            const sortingDate = (value) => {
                return moment(value).format('YYYY-MM');
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            const data = res.data.result.content.data.map((e) => {
                                return Object.assign(Object.assign({}, e), { periodSort: sortingDate(e.periodFrom) });
                            });
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST, data);
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE, res.data.result.content.paging);
                        }
                        else {
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST, []);
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE, {
                                currentPage: 0,
                                totalPages: 0,
                                totalElements: 0,
                                errorRows: 0,
                                readyToUpload: 0
                            });
                        }
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_7 = Actions.GET_BUDGET_SUMMARY_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST_ID, []);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST_DESC, []);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST_VERSION, []);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetheader/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '999999',
                Desc: this.desc,
                Version: [],
                BudgetTypeDesc: []
            };
            const dataId = [];
            const dataDesc = [];
            const dataVersion = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _29;
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            (_29 = res.data.result.content) === null || _29 === void 0 ? void 0 : _29.data.map((data) => {
                                if (dataId.length === 0) {
                                    dataId.push({
                                        value: data.budgetTypeID,
                                        label: data.budgetTypeDesc
                                    });
                                }
                                else {
                                    const findId = dataId.find((element) => {
                                        return element.value === data.budgetTypeID;
                                    });
                                    if (findId === undefined) {
                                        dataId.push({
                                            value: data.budgetTypeID,
                                            label: data.budgetTypeDesc
                                        });
                                    }
                                }
                                if (dataDesc.length === 0) {
                                    dataDesc.push({
                                        value: data.budgetTypeDesc,
                                        label: data.budgetTypeDesc
                                    });
                                }
                                else {
                                    const findDesc = dataDesc.find((element) => {
                                        return element.value === data.budgetTypeDesc;
                                    });
                                    if (findDesc === undefined) {
                                        dataDesc.push({
                                            value: data.budgetTypeDesc,
                                            label: data.budgetTypeDesc
                                        });
                                    }
                                }
                                if (dataVersion.length === 0) {
                                    dataVersion.push({
                                        value: data.version,
                                        label: data.version
                                    });
                                }
                                else {
                                    const findVersion = dataVersion.find((element) => {
                                        return element.value === data.version;
                                    });
                                    if (findVersion === undefined) {
                                        dataVersion.push({
                                            value: data.version,
                                            label: data.version
                                        });
                                    }
                                }
                            });
                        }
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST_DESC, dataDesc);
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST_VERSION, dataVersion);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_8 = Actions.CREATE_BUDGET_SUMMARY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_9 = Actions.UPDATE_BUDGET_SUMMARY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_10 = Actions.GET_BUDGET_SUMMARY_LIST_FILTER](data) {
        var _29, _30, _31, _32;
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_VERSION, data.version);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DESC, data.budgetTypeDesc);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DATE_FROM, data.periodFrom === undefined || ((_29 = data.periodFrom) === null || _29 === void 0 ? void 0 : _29.length) === 0
                ? []
                : moment(data.periodFrom).format('YYYY-MM'));
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DATE_TO, data.periodTo === undefined || ((_30 = data.periodTo) === null || _30 === void 0 ? void 0 : _30.length) === 0
                ? []
                : moment(data.periodTo).format('YYYY-MM'));
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetheader/filter?` +
                new URLSearchParams(params).toString();
            const PeriodFrom = data.periodFrom === undefined || ((_31 = data.periodFrom) === null || _31 === void 0 ? void 0 : _31.length) === 0
                ? []
                : [moment(data.periodFrom).format('YYYYMM')];
            const PeriodTo = data.periodTo === undefined || ((_32 = data.periodTo) === null || _32 === void 0 ? void 0 : _32.length) === 0
                ? []
                : [moment(data.periodTo).format('YYYYMM')];
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc,
                Version: data.version,
                BudgetTypeDesc: data.budgetTypeDesc,
                PeriodFrom,
                PeriodTo
            };
            const sortingDate = (value) => {
                return moment(value).format('YYYY-MM');
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _29, _30;
                    if (res.status === 200) {
                        const data = res.data.result.content.data.map((e) => {
                            return Object.assign(Object.assign({}, e), { periodSort: sortingDate(e.periodFrom) });
                        });
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LIST, data);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE, ((_29 = res.data.result.content) === null || _29 === void 0 ? void 0 : _29.paging) || []);
                        }
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE, ((_30 = res.data.result.content) === null || _30 === void 0 ? void 0 : _30.paging) || []);
                        resolve(true);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_11 = Actions.GET_BUDGET_SUMMARY_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_BUDGET_SUMMARY_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_BUDGET_SUMMARY_LIST_FILTER, {
                    budgetTypeDesc: this.selectedCategoryDesc,
                    version: this.selectedCategoryVersion
                    // periodTo: this.selectedCategoryYear,
                });
            }
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_LIST_ID_DESC);
        });
    }
    [_12 = Actions.UPDATE_SELECTED_BUDGET_SUMMARY_ID](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_ID, data);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
        });
    }
    [_13 = Actions.UPDATE_SELECTED_BUDGET_SUMMARY_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DESC, data);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
        });
    }
    [_14 = Actions.UPDATE_SELECTED_BUDGET_SUMMARY_VERSION](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_VERSION, data);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
        });
    }
    // @Action
    // async [Actions.UPDATE_SELECTED_BUDGET_SUMMARY_YEAR](data) {
    //   this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_YEAR, data);
    //   this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE, 1);
    //   this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
    // }
    [_15 = Actions.UPDATE_BUDGET_SUMMARY_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_SIZE, data);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
        });
    }
    [_16 = Actions.RESET_BUDGET_SUMMARY_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_VERSION, []);
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DATE_FROM, '');
            this.context.commit(Mutations.SET_SELECTED_BUDGET_SUMMARY_DATE_TO, '');
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
        });
    }
    [_17 = Actions.DOWNLOAD_TEMPLATE_BUDGET_SUMMARY]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/budget/upload/downloadtemplate?ver=v1`;
            axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob',
                data: {}
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Template Budget Summary.xlsx');
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_18 = Actions.DOWNLOAD_BUDGET_SUMMARY]() {
        var _29, _30;
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/budgetheader/download?ver=v1`;
            const periodFrom = this.selectedCategoryDateFrom === undefined ||
                ((_29 = this.selectedCategoryDateFrom) === null || _29 === void 0 ? void 0 : _29.length) === 0
                ? []
                : [moment(this.selectedCategoryDateFrom).format('YYYYMM')];
            const periodTo = this.selectedCategoryDateTo === undefined ||
                ((_30 = this.selectedCategoryDateTo) === null || _30 === void 0 ? void 0 : _30.length) === 0
                ? []
                : [moment(this.selectedCategoryDateTo).format('YYYYMM')];
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    budgetTypeDesc: this.selectedCategoryDesc,
                    version: this.selectedCategoryVersion.length > 0
                        ? this.selectedCategoryVersion.toString().split(',')
                        : [],
                    periodFrom,
                    periodTo
                }
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Budget.xlsx');
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_19 = Actions.GET_BUDGET_SUMMARY_TYPE]() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgettype/lookup?` +
                new URLSearchParams(params).toString();
            const dataBudgetType = [];
            return new Promise((resolve, reject) => {
                ApiService.get(url, '')
                    .then((res) => {
                    if (res.status === 200) {
                        res.data.result.content.map((data) => {
                            dataBudgetType.push({
                                value: data.budgetTypeID,
                                label: data.budgetTypeDesc
                            });
                        });
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_TYPE, dataBudgetType);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_20 = Actions.GET_BUDGET_SUMMARY_VERSION](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion/lookup?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_VERSION, res.data.result.content.length);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_21 = Actions.CREATE_VALIDATE_BUDGET_SUMMARY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_VALIDATE, []);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE_VALIDATE, []);
            const params = {
                ver: 'v1',
                Page: this.pageValidate.toString(),
                Size: this.sizeValidate.toString()
            };
            const formdata = new FormData();
            formdata.append('BudgetDetail', data);
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/budget/upload/validate?` +
                new URLSearchParams(params).toString();
            return new Promise((resolve, reject) => {
                ApiService.post(apiUrl, formdata)
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_VALIDATE, res.data.result.content.data);
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE_VALIDATE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE_VALIDATE, true);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_22 = Actions.UPDATE_VALIDATE_BUDGET_SUMMARY_PAGE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE_VALIDATE, data);
        });
    }
    [_23 = Actions.UPDATE_VALIDATE_BUDGET_SUMMARY_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_SIZE_VALIDATE, data);
        });
    }
    [_24 = Actions.DOWNLOAD_VALIDATE_BUDGET_SUMMARY]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/budget/upload/download?BudgetHeaderId=&ver=v1`;
            axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob'
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Detail Budget Summary.xlsx');
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_25 = Actions.GET_BUDGET_SUMMARY_DETAIL](id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budget/upload/budgetdetail`;
            const params = {
                ver: 'v1',
                Page: this.pageDetail.toString(),
                Size: this.sizeDetail.toString(),
                Desc: this.descDetail,
                BudgetHeaderId: id
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_DETAIL, res.data.result.content.data);
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_PAGE_DETAIL, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_LOAD_PAGE_DETAIL, true);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_26 = Actions.DOWNLOAD_BUDGET_SUMMARY_DETAIL](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/budget/upload/download?BudgetHeaderId=${data.budgetHeaderID}&ver=v1`;
            axios({
                url: apiUrl,
                method: 'GET',
                responseType: 'blob' // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${data.fileName}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_27 = Actions.UPDATE_BUDGET_SUMMARY_DETAIL_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_DETAIL_SIZE, data.page);
            this.context.commit(Mutations.SET_BUDGET_SUMMARY_HANDLE_PAGE_DETAIL, 1);
            this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DETAIL, data.id);
        });
    }
    [_28 = Actions.CREATE_SUBMIT_BUDGET_SUMMARY_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budget/upload/submit?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_BUDGET_SUMMARY_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_BUDGET_SUMMARY_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _t, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _u, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _v, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _w, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _x, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _y, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _z, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _0, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _1, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _2, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _3, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _4, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BudgetSummaryModule.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _8, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _9, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _10, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _11, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _12, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _13, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _14, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _15, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _16, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _17, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _18, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _19, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _20, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _21, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _22, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _23, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _24, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _25, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _26, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _27, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], BudgetSummaryModule.prototype, _28, null);
BudgetSummaryModule = __decorate([
    Module
], BudgetSummaryModule);
export default BudgetSummaryModule;
